// Job requirements *******************************************************************************
// pathname: /v1/job-interview/{jobSlug}/job-requirements
// ************************************************************************************************
import { useSwrApi } from '@hooks/useSwrApi';

/** Props */
interface UseSwrJobRequirementsProps {
  locale: Locale,
  jobSlug: string,
  shouldFetch?: boolean,
}

/**
 * @description SWR: fetch job requirement questions.
 * - `locale` - the current locale
 * - `jobSlug` - the job slug
 * - `shouldFetch` - condition for fetching the data. Default true.
 */
export const useSwrJobRequirements = (props: UseSwrJobRequirementsProps) => {
  const {
    locale,
    jobSlug,
    shouldFetch = true,
  } = props;

  return useSwrApi<ApiSchema<'RequirementQuestionListRead'>>({
    url: `/v1/job-interview/${jobSlug}/job-requirements`,
    locale,
    shouldFetch,
    apiOptions: {
      revalidateOnFocus: false,
      revalidateOnMount: true,
    },
    toastsOptions: {
      showErrorToast: true,
    },
  });
};
